import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '1 — Is this a physical product?',
    a: 'No. Kit The Focused Mindset™ is 100% digital. After purchase you receive a download link via email. No apps or extra platforms needed. Start printing within minutes.'
  }, {
    q: '2 — What age is this designed for?',
    a: 'The system covers ages 3 to 12 with 6 separate volumes, each built for a specific developmental stage. One purchase covers your child today and every level as they grow.'
  }, {
    q: '3 — Do I need teaching experience?',
    a: 'Not at all. Every activity includes simple clear instructions. The Parent Quick-Start Guide walks you through the full system in 15 minutes. If you can sit next to your child for 10 minutes, you can do this.'
  }, {
    q: '4 — What if my child has ADHD or learning difficulties?',
    a: 'The system was designed with progressive simplicity in mind. Many parents of children with ADHD, sensory sensitivities, and learning differences report it as one of the few systems their child actually completes. We recommend starting with Volume 1 regardless of age to build the habit first.'
  }, {
    q: '5 — How many children can use this?',
    a: 'One purchase covers your entire family forever. Print as many copies as you need for as many children as you have. No restrictions. No additional fees. Ever.'
  }, {
    q: '6 — What makes this different from free worksheets online?',
    a: 'Free worksheets are random. Kit The Focused Mindset™ is a progressive brain training system where every activity builds on the last one — targeting focus, memory, logic, and emotional regulation in the exact order a developing brain needs. That structure is what creates real lasting results.'
  }, {
    q: '7 — Does my child need a screen to use this?',
    a: 'Never. Everything is designed to be printed and used with a pencil, crayon, or pen. Zero screen time required. That is the entire point.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-lightgray py-16 px-4" data-id="element-61">
      <div className="max-w-3xl mx-auto" data-id="element-62">
        <h2 className="text-3xl md:text-4xl font-heading font-black text-center mb-10 text-white" data-id="element-63">
          ❓ FREQUENTLY ASKED QUESTIONS
        </h2>

        <div className="space-y-4" data-id="element-64">
          {faqs.map((faq, i) => <div key={i} className="bg-navy border border-white/10 rounded-xl overflow-hidden shadow-sm" data-id="element-65">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-white/5 transition-colors" data-id="element-66">
                <span className="font-heading font-bold text-white text-base md:text-lg pr-4" data-id="element-67">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-orange transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-68" />
              </button>
              <AnimatePresence data-id="element-69">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-70">
                    <div className="px-6 pb-5 text-muted border-t border-border pt-4 text-sm md:text-base font-medium leading-relaxed" data-id="element-71">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}